export default class ListResponseModel {
  constructor(data, resultsModel) {
    if (!data) {
      data = {};
    }

    // if we end up with an array, just bail on the paging
    if (data.length) {
      this.results = (data || []).map(r => new resultsModel(r));
      this.count = this.results.length;
      this.next = '';
      this.previous = '';
    } else {
      this.count = data.count || 0;
      this.next = data.next || '';
      this.previous = data.previous || '';
      this.results = (data.results || []).map(r => new resultsModel(r));
    }
  }

  get items() {
    return this.results;
  }
}
